import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn('size-4 animate-spin', className)} aria-hidden />;
}

/** Centred spinner with a screen-reader label, for full-panel loading. */
export function LoadingPanel({ className, label }: { className?: string; label?: string }) {
  const { t } = useTranslation();

  return (
    <div
      className={cn('flex items-center justify-center gap-3 py-16', className)}
      role="status"
      aria-live="polite"
    >
      <Spinner className="text-muted-foreground size-5" />
      <span className="text-muted-foreground text-sm">{label ?? t('table.loading')}</span>
    </div>
  );
}
